import { PatternFormat } from 'react-number-format';
import parse from 'html-react-parser';
import { BrregElementType, InputmaskElementType } from '../helpers/types';

type PropType = {
    value: string;
    onChange: (value: string) => void;
    error: string | null;
};

const InputMask = (props: (InputmaskElementType | BrregElementType) & PropType) => {
    const { value, mask, label, placeholder, onChange, replace, replaceWith, error, description } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const transformedValue = e.target.value.replaceAll(replace ?? ' ', replaceWith ?? '');
        onChange(transformedValue);
    };

    return (
        <>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <PatternFormat
                value={value}
                format={mask || ''}
                mask=""
                patternChar="0"
                className={`form-control ${error && value ? 'is-invalid' : value ? 'is-valid' : ''}`}
                placeholder={placeholder}
                onChange={handleChange}
            />
            {error && value && error !== "hidden" && <div className="invalid-feedback">{parse(error)}</div>}
        </>
    );
};

export default InputMask;